import React from "react";

const STYLE_COLORS = {
  minimal: { bg: "#f0f4ff", accent: "#3f73f9" },
  vivid: { bg: "linear-gradient(135deg, #ff6b35, #f7c59f)", accent: "#fff" },
  premium: { bg: "linear-gradient(135deg, #1a1a2e, #0f3460)", accent: "#c9a84c" },
};

function BannerThumb({ variant, formData }) {
  const cfg = STYLE_COLORS[variant?.style] || STYLE_COLORS.minimal;
  return (
    <div
      className="aic-history-thumb"
      style={{ background: cfg.bg }}
    >
      {variant?.imageUrl ? (
        <img src={variant.imageUrl} alt="" className="aic-history-thumb__img" />
      ) : (
        <div className="aic-history-thumb__mock">
          <div style={{ color: cfg.accent, fontSize: 8, fontWeight: 700, textAlign: "center" }}>
            {formData?.brandName?.slice(0, 10)}
          </div>
        </div>
      )}
    </div>
  );
}

function HistoryItem({ generation, onViewResizes }) {
  const date = new Date(generation.createdAt);
  const dateStr = date.toLocaleDateString("ru-RU", { day: "2-digit", month: "short", year: "numeric" });
  const timeStr = date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });

  const selectedVariant = generation.variants?.find((v) => v.id === generation.selectedVariantId) || generation.variants?.[0];

  return (
    <div className="aic-history-item">
      <div className="aic-history-item__thumbs">
        {(generation.variants || []).slice(0, 3).map((v) => (
          <BannerThumb key={v.id} variant={v} formData={generation.formData} />
        ))}
      </div>

      <div className="aic-history-item__info">
        <div className="aic-history-item__brand">{generation.formData?.brandName || "—"}</div>
        <div className="aic-history-item__offer">{generation.formData?.offer?.slice(0, 50)}</div>
        <div className="aic-history-item__meta">
          <span className="aic-history-item__date">{dateStr}, {timeStr}</span>
          {generation.resizes?.length > 0 && (
            <span className="aic-history-item__badge">
              {generation.resizes.length} ресайза
            </span>
          )}
        </div>
      </div>

      {generation.resizes?.length > 0 && (
        <button
          className="aic-btn aic-btn--outline aic-btn--sm"
          onClick={() => onViewResizes(generation)}
        >
          Посмотреть
        </button>
      )}
    </div>
  );
}

export default HistoryItem;
